import React from 'react'
import { Button } from 'reactstrap'

interface SaveButtonProps {
  hasChanges: boolean
  isSaving: boolean
  hasErrors: boolean
  onSave: () => void
}

const SaveButton: React.FC<SaveButtonProps> = ({
  hasChanges,
  isSaving,
  hasErrors,
  onSave,
}) => {
  if (!hasChanges) return null

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 1000,
      }}
    >
      <Button
        color="success"
        size="lg"
        onClick={onSave}
        disabled={isSaving || hasErrors}
        className="shadow-lg"
      >
        {isSaving ? (
          <>
            <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
            Saving...
          </>
        ) : (
          <>
            <i className="bx bx-save font-size-16 align-middle me-2"></i>
            Save Changes
          </>
        )}
      </Button>
    </div>
  )
}

export default SaveButton
